// extracted by mini-css-extract-plugin
module.exports = {"loginError":"_FormErrorBox_loginError__1iA3w","error":"_FormErrorBox_error__Xi1rI","alertIcon":"_FormErrorBox_alertIcon__2nG5z"};